export const BASE_API_URL = 
    process.env.NODE_ENV === 'development' 
        ? 'http://localhost:15301' 
        : (window.location.href.split(".")[2] === "staging" 
            ? 'https://lkmtraining.nomination.staging.accenture.com/trainingnominationstage-apis' 
            : 
            'https://lkmtraining.nomination.accenture.com/LKMtrainingNomination-apis'
)